// extracted by mini-css-extract-plugin
export default {"root":"VideoPlayer__root--4ghCq","audioIcon":"VideoPlayer__audioIcon--2eOGg"};